/*
FORKED from http://jedwatson.github.io/classnames
*/

(function() {
  let hasOwn = {}.hasOwnProperty;

  function classNames() {
    let classes = [];

    for (let i = 0; i < arguments.length; i++) {
      let arg = arguments[i];
      if (!arg) {
        continue;
      }

      let argType = typeof arg;

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        let inner = classNames.apply(null, arg);
        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        for (let key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }

    function flatten() {
      if (__NATIVE__ && arguments.length > 0) {
        const styles = require('lodash/defaultsDeep')(...arguments);
        return require('react-native').StyleSheet.flatten(
          classes.map(style => styles[style])
        );
      }
      return classes.join(' ');
    }

    let classesStr = classes.join(' ');
    classesStr.__proto__.flatten = flatten;

    return classesStr;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = classNames;
  } else if (
    typeof define === 'function' &&
    typeof define.amd === 'object' &&
    define.amd
  ) {
    // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
      return classNames;
    });
  } else {
    window.classNames = classNames;
  }
})();
